import React, { FC, useEffect, useState } from 'react';
import cx from 'classnames';

import styles from './RecentSaleTimeStamp.scss';

type RecentSaleTimeStampProps = {
  className?: string;
  timestamp?: string;
};

export const RecentSaleTimeStamp: FC<RecentSaleTimeStampProps> = ({ className, timestamp }) => {
  const [show, setShow] = useState(false);

  useEffect(() => setShow(true), []);

  return (
    <div className={ cx(styles.date, className) }>
      {(show && timestamp) || '\u00A0'}
    </div>
  );
};
